/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PresignUploadDto,
  PresignUploadResponseDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getUploadsControllerPresignV1Url = () => {




  return `/v1/uploads/presign`
}

/**
 * The returned `key` is what you persist. The `uploadUrl` accepts a single PUT whose Content-Type header must equal the requested `contentType`, because it is signed into the URL.
 * @summary Get a one-shot URL for uploading a file straight to storage
 */
export const uploadsControllerPresignV1 = async (presignUploadDto: PresignUploadDto, options?: RequestInit): Promise<PresignUploadResponseDto> => {

  return apiRequest<PresignUploadResponseDto>(getUploadsControllerPresignV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(presignUploadDto)
  }
);}





export const getUploadsControllerPresignV1QueryKey = (presignUploadDto?: PresignUploadDto,) => {
    return [
    'POST', `/v1/uploads/presign`, presignUploadDto
    ] as const;
    }


export const getUploadsControllerPresignV1QueryOptions = <TData = Awaited<ReturnType<typeof uploadsControllerPresignV1>>, TError = unknown>(presignUploadDto: PresignUploadDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof uploadsControllerPresignV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUploadsControllerPresignV1QueryKey(presignUploadDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof uploadsControllerPresignV1>>> = ({ signal }) => uploadsControllerPresignV1(presignUploadDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof uploadsControllerPresignV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UploadsControllerPresignV1QueryResult = NonNullable<Awaited<ReturnType<typeof uploadsControllerPresignV1>>>
export type UploadsControllerPresignV1QueryError = unknown


export function useUploadsControllerPresignV1<TData = Awaited<ReturnType<typeof uploadsControllerPresignV1>>, TError = unknown>(
 presignUploadDto: PresignUploadDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof uploadsControllerPresignV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof uploadsControllerPresignV1>>,
          TError,
          Awaited<ReturnType<typeof uploadsControllerPresignV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUploadsControllerPresignV1<TData = Awaited<ReturnType<typeof uploadsControllerPresignV1>>, TError = unknown>(
 presignUploadDto: PresignUploadDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof uploadsControllerPresignV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof uploadsControllerPresignV1>>,
          TError,
          Awaited<ReturnType<typeof uploadsControllerPresignV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUploadsControllerPresignV1<TData = Awaited<ReturnType<typeof uploadsControllerPresignV1>>, TError = unknown>(
 presignUploadDto: PresignUploadDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof uploadsControllerPresignV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a one-shot URL for uploading a file straight to storage
 */

export function useUploadsControllerPresignV1<TData = Awaited<ReturnType<typeof uploadsControllerPresignV1>>, TError = unknown>(
 presignUploadDto: PresignUploadDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof uploadsControllerPresignV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUploadsControllerPresignV1QueryOptions(presignUploadDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






